<div class="cg-dialog" *ngrxLet="isDentalUser$ as isDentalUser">
  <h3 class="cg-dialog__header">
    <span *ngIf="data?.title">{{ data.title }}</span>
    <span *ngIf="!data?.title">{{
      'shared.dialog.explainAccess.header' | translate
    }}</span>
    <button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="dialogRef.close()"
    >
      {{ 'shared.dialog.explainAccess.closeBtn' | translate }}
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h3>
  <p>{{ 'shared.dialog.explainAccessNew.descriptionDfd' | translate }}</p>
  <mat-dialog-content style="max-height: 45vh">
    <p
      *ngIf="appContext === 'chcp' && !isDentalUser"
      [innerHTML]="
        'shared.dialog.explainAccessNew.cccClinicalRepPortal' | translate
      "
    ></p>
    <p
      [innerHTML]="'shared.dialog.explainAccessNew.reconsideration' | translate"
    ></p>
    <p
      [innerHTML]="'shared.dialog.explainAccessNew.claimsearch' | translate"
    ></p>
    <p
      [innerHTML]="'shared.dialog.explainAccessNew.delegateDfd' | translate"
    ></p>
    <p [innerHTML]="'shared.dialog.explainAccessNew.directory' | translate"></p>
    <p [innerHTML]="'shared.dialog.explainAccessNew.eft' | translate"></p>

    <p
      *ngIf="appContext === 'chcp' && !isDentalUser"
      [innerHTML]="
        'shared.dialog.explainAccessNew.iCollabClinicalRepPortal' | translate
      "
    ></p>
    <p
      *ngIf="appContext === 'chcp' && isDentalUser"
      [innerHTML]="
        'shared.dialog.explainAccessNew.patientsearchDfdDental' | translate
      "
    ></p>
    <p
      *ngIf="
        (appContext === 'chcp' && !isDentalUser) || appContext === 'evernorth'
      "
      [innerHTML]="
        'shared.dialog.explainAccessNew.patientsearchDfd' | translate
      "
    ></p>

    <p
      [innerHTML]="'shared.dialog.explainAccessNew.remittance' | translate"
    ></p>
  </mat-dialog-content>
</div>
